//This file is automatically rebuilt by the Cesium build process.
export default "/**\n\
 * The automatic GLSL constant for {@link Pass#TRANSLUCENT}\n\
 *\n\
 * @name czm_passTranslucent\n\
 * @glslConstant\n\
 *\n\
 * @see czm_pass\n\
 */\n\
const float czm_passTranslucent = 9.0;\n\
";
